import { Engine } from 'engine/Engine';
import { Entity } from '../Entity';

const entity = new Entity({});

export abstract class Facet<P = {}> {

  entity: Entity;

  constructor(public props: P) {
    this.props = props;
    this.entity = entity;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  start(engine: Engine) {}

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  update(delta: number, engine: Engine) {}

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  physicsUpdate(delta: number, engine: Engine) {}

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  stop(engine: Engine) {}
}
